import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import IconProvider from "@/components/ui/IconProvider";

interface HeadingDropdownProps {
  onFormat: (command: string, value?: string) => void;
}

const headingOptions = [
  { value: 'h1', label: "H1" },
  { value: 'h2', label: "H2" },
  { value: 'h3', label: "H3" },
  { value: 'p', label: "Paragraph" },
];

export const HeadingDropdown = ({ onFormat }: HeadingDropdownProps) => {
  const handleHeadingSelect = (value: string) => {
    onFormat('formatBlock', value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-r border-gray-200"
        >
          <IconProvider iconstring="fa-heading" size={14} />
          <IconProvider iconstring="fa-chevron-down" size={12} className="ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        {headingOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleHeadingSelect(option.value)}
            className="text-sm"
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 